import { useState } from 'react';

/**
 * Sends a paginated list back to its first page when its filters change.
 *
 * Done during render rather than in an effect on purpose. An effect runs after
 * the render that already carries the new filters has committed, so the loader
 * fires once against the stale page and again after the reset — one wasted
 * request per filter change made while paginated, plus a race between the two
 * responses. Setting state during render makes React discard that render and
 * redo it with both values already correct, so the list loads exactly once.
 *
 * `filterKey` is every filter that should reset the page, joined into one
 * string.
 */
export function usePageResetOnFilterChange(
  filterKey: string,
  page: number,
  setPage: (page: number) => void,
): void {
  const [previousKey, setPreviousKey] = useState(filterKey);

  if (previousKey !== filterKey) {
    setPreviousKey(filterKey);
    if (page !== 0) {
      setPage(0);
    }
  }
}
